<template>
    <div class="msg-container">
        <div class="msg" v-if="status == 1">
            <img src="@/assets/images/waiting-checkout.svg" />
            <p>
                {{ $t("Please waiting untill transaction end") }}
            </p>
        </div>
        <div class="msg" v-if="status == 2">
            <img src="@/assets/images/success-checkout.svg" />
            <h5 class="title">{{ $t("Payment done successful") }}</h5>
            <p>
                {{ $t("We will redirect you to your invoices after 5 sec") }}
            </p>
        </div>
        <div class="msg" v-if="status == 3">
            <img src="@/assets/images/checkout-error.svg" />
            <h5 class="title">{{ $t("Error in transaction") }}</h5>
            <p class="error-msg" v-if="error_msg">
                {{ error_msg }}
            </p>
            <p>
                {{
                    $t(
                        "We will redirect you to checkout page again after 5 sec"
                    )
                }}
            </p>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            status: 1,
            error_msg: null,
        };
    },
    created() {
        if (Object.keys(this.$route.query).length) {
            this.$store
                .dispatch("invoice_store_transaction", this.$route.query)
                .then((res) => {
                    this.status = 2;
                    let url = document.location.href;
                    window.history.pushState({}, "", url.split("?")[0]);
                    this.$buefy.toast.open({
                        message: this.$t("Transaction has been stored"),
                        type: "is-primary",
                    });
                    setTimeout(() => {
                        this.$router.push("/invoices");
                    }, 5000);
                })
                .catch((error) => {
                    this.status = 3;
                    sessionStorage.setItem("transaction_error", error);
                    this.error_msg = error;
                    setTimeout(() => {
                        this.$router.go(-1);
                    }, 5000);
                });
        } else {
            this.$router.push("/home");
        }
    },
};
</script>

<style lang="scss">
.msg-container {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;

    .error-msg {
        border: 1px solid tomato;
        padding: 10px 10px;
        margin: 10px;
        color: tomato;
        font-size: 14px;
    }

    .msg {
        width: 65%;
        background: white;
        border-radius: 10px;
        padding: 30px 10px;
        margin: 10px 0;
        text-align: center;

        .title {
            color: #777 !important;
        }

        img {
            height: 100px;
        }
    }
}
</style>
